const removeFormErrors = () => {
	let forms = nfRadio.channel( 'app' ).request( 'get:forms' );

	forms.each( function( form ) {
		let formFields = form.get( 'fields' );

		if ( !formFields ) {
			return;
		}

		formFields.models.forEach( fieldModel => {
			if ( fieldModel.get( 'errors' ).length ) {
				nfRadio.channel( 'fields' ).request( 'remove:error', fieldModel.get( 'id' ), 'required-error' );
			}
		} );
	} );
};

$( document ).on( 'nfFormSubmitResponse', function( event, response ) {
	const handleError = () => {
		removeFormErrors();
	};

	// const handleSuccess = () => {
	// }

	if ( Object.keys( response.response.errors ).length ) {
		handleError();
		return;
	}

	// handleSuccess();
} );
